import { createElement } from "react";
import styles from "./ClickHeading.module.scss";

const ClickHeading = ({ tag, children }) =>
  !["h1", "h2", "h3", "h4"].includes(tag)
    ? children
    : createElement(tag, { className: styles.heading }, children);

export default ClickHeading;
